import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

/**
 * Takes care of reordering the selection area if needed, ensuring that start is always before end
 * @param positionA -
 * @param positionB -
 */
export const normalizeSelectionArea = ([positionA, positionB]: [
  RelativeAbsolutePosition,
  RelativeAbsolutePosition,
]): [RelativeAbsolutePosition, RelativeAbsolutePosition] => {
  let start: RelativeAbsolutePosition;
  let end: RelativeAbsolutePosition;

  const draggingLeft = positionA.relative.x > positionB.relative.x;

  if (draggingLeft) {
    start = positionB;
    end = positionA;
  } else {
    start = positionA;
    end = positionB;
  }

  return [start, end];
};
